<template>
    <div class="pardata_box">
    	<div class="back_box" @click="back()">
          <img src="../../../static/images/back.png" alt="">
          	返回上一页
    	</div>
    	<h2>查看并操作</h2>
        <ParheaderVue :caseid="caseid" :token="token"/>
       <parinf :dataArr='objdata'></parinf>
        <div class="req_box">
           <p><b>救援请求</b></p>
           <div class="box_req">
               <ul>
                   <li>
                       <div class="rescue_box">
                         <div class="box" v-for="(v,ind) in obj" :key="ind">
                          <p style="line-height: 30px;font-size: 14px;" v-if="v.dict.parentId===0"><b>{{v.dict.name}}服务清单</b></p>
                         </div>
                         <div class="box">
                            <fuwuqingdan :attaArr=obj.slice(1,obj.length)></fuwuqingdan>
                         </div>
                       </div>
                   </li>
               </ul>
           </div>
           <p><b>江泰指挥中心救援整体说明</b></p>
           <div class="box_exp">
             <p><span class="res_box_exp">说明：{{setTxt(stateText,'zh') || '无'}}</span></p>
             <attaList :attaArr="acc_list"></attaList>
           </div>
            <p><b>整体说明</b></p>
           <div class="com_exp">
				<p class="res_box_exp">说明：{{setTxt(stateText2,'zh') || '无'}}</p>
             	<attaList :attaArr="acc_list1"></attaList>
           </div>
        </div>
    </div>
</template>

<script>
import qs from "qs";
import { Message } from "element-ui";
import "isomorphic-fetch";
import constants from '@/util/constants.js';
import Promise from 'promise-polyfill';
import fuwuqingdan from "@/components/attachment/qingdan1";
import ParheaderVue from "../par/parheader.vue";
import attaList from "@/components/attachment/index1";
import parinf from "@/components/par/Parinf";
if (!window.Promise) {
  window.Promise = Promise;
}
export default {
  data() {
    let that = this;
    return {
      file:null,
      upacc: false,
      exp: "",
      token: this.$route.params.token|| JSON.parse(window.localStorage.getItem("data")).data,
      obj: [],
      txts: "",
      objdata: {
        add: "出险地:",
        type: "事故类型：风险灾害 ",
        part: "受伤部位：腿部 ",
        weather: "天气灾害：气象灾害 "
      },
      acc_list: [],
      acc_list1: [],
      up_acc: [
        {
          icon: "../../../static/images/eles_no.png",
          description: ""
        }
      ],
      checkList: [],
      def: "",
      bid: [],
      inf: null,
      url: "",
      caseid: this.$route.query.caseid,
      stateText:"",
      stateText2:"",
    };
  },
  components:{
  	fuwuqingdan,
  	ParheaderVue,
  	attaList,
		parinf
  },
  methods: {
			setTxt(str,status){
				return constants.setTxt(str,status)
			},		
    apply() {
      let that = this;
      let tUploadCnts=this.up_acc.slice();
      tUploadCnts.shift();
      this.axios
        .post(
          constants.domain+"rescue/bidding/author_rescue",
          qs.stringify({
            token: this.token, //token值
            caseId: this.caseid, //caseid
            stateText2: this.exp, //说明
            upaccStr:JSON.stringify(tUploadCnts),        
          })
        )
        .then(res => {
          if (res.data.code === 0) {
            that.$router.push({
              path: "/regulator/caseindex/await",
              name: "RegAwait",
              params: {
                token: this.token
                // obj: this.inf,
                // data: this.obj
              },
              query: {
                typeId: this.$route.query.typeId
              }
            });
            
          }
        });
    },

    loadauxfiles(){
      let that = this;
      fetch(constants.domain+"rescue/case/upload_cnts", {
         method: "POST",
         body: `token=${that.token}&objId=${this.$route.query.caseid}&caseId=${this.$route.query.caseid}&objType=1`,
         mode: "cors",
      headers: { "Content-Type": "application/x-www-form-urlencoded" }
      })
      .then(function(res) {
           //console.log(res);
       return res.json();
       })
         .then(function(data) {
         	var arr=[]
            data.obj.map(v => {
              if(constants.isPic(v.url)){
                v.icon=v.url;
              }else{
                v.icon="../../../static/images/eles_icon.png";
              }
              arr.push(v);
            });
             that.acc_list=arr.filter(item=>{
            	return item.type == '120'
            })
            that.acc_list1=arr.filter(item=>{
            	return item.type == '130'
            })               
         });
    },
    up() {
      console.log(this.url);
      let flag = constants.isPic(this.url);
        
      if (flag) {
        this.up_acc.push({
          url: this.url,
          description: this.txts,
          icon:this.url,
        });
      } else if (!flag) {
        if (this.url == "") {
          Message.error("请上传附件");
        } else {
          this.up_acc.push({
            url: this.url,
            description: this.txts,
            icon: "../../../static/images/eles_icon.png"
          });
        }
      }
    },
    handleGetFile(e) {      
      this.file = e.target.files[0];
      this.txts = this.file.name;
    },
    uploadFile(){
      let that = this;
      var reader = new FileReader();
      reader.readAsDataURL(this.file);
      let formdata = new FormData();
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      formdata.append(
        "token",
        this.$route.params.token ||
          JSON.parse(window.localStorage.getItem("data")).data
      );
      reader.onload = function(e) {
        that.avatar = this.result;
        formdata.append("file", that.file);
        that.axios
          .post(
            constants.domain+"rescue/case/upload_file",
            formdata,
            config
          )
          .then(res => {
            that.url = res.data.obj;
            that.up();
          });
      };
    },
    back() {
      let that = this;
      console.log(that.token);
      this.$router.push({
        name: "RegOffer",
        params: {
          token: that.token
        },
        query: {
          typeId:this.$route.query.typeId
        }
      });
    },
  },
  mounted() {
    let that = this;
    fetch(constants.domain+"rescue/case/detail_case", {
      method: "POST",
      body: `token=${this.token}&caseId=${this.caseid}`,
      mode: "cors",
      headers: { "Content-Type": "application/x-www-form-urlencoded" }
    })
      .then(function(res) {
        return res.json();
      })
      .then(function(data) {
        that.stateText = data.obj.obj.stateText;
        that.stateText2 = data.obj.obj.stateText2;
        that.obj = data.obj2;
          let addr = "";
          if (data.obj.generalLocation) {
            addr = data.obj.generalLocation.addr || "";
          }
          that.objdata = {
            add:
              "出险地:" +
              (data.obj.caseCountry || "") +
              (data.obj.caseCity || "") +
              addr,
            type: "事故类型：" + (data.obj.obj.accidentType||""),
            part: "受伤部位：" + (data.obj.victimList[0].obj.injuredPart||""),
            weather: "天气灾害：" + (data.obj.obj.weatherTag || "无")
          };
          that.def = data.obj.obj.incidentDesc;
      })
      this.loadauxfiles();
  }
};
</script>

<style scoped>
@import url(../../css/parinf.css);
.data_wrap{margin-top: 20px;margin-left: 35px;}
.req_box{margin-left: 35px;}
.back_box{margin-bottom: 10px;cursor: pointer;}
h2{font-size: 18px;}
.box_exp{margin-left: 43px;}
.com_exp{padding-left: 40px;}
</style>


// WEBPACK FOOTER //
// src/components/regulator/resstep.vue